<template>
  <div class="el_container">
    <div class="ly_title">診断中・・・</div>
    <div v-if="sendResultFailed">
      <div class="ly_title">エラーが発生しました</div>
      <MaterialButton
        class="el_round_button"
        @click="sendResult"
        text="リトライ"
        link=""
        font-size="28px"
        padding="10px 52px 10px 52px"
        :enabled = "!isSending"
      />
    </div>
  </div>
</template>

<script>
import MaterialButton from '../atoms/MaterialButton.vue'

export default {
  name: 'SendResult',
  components: {
    MaterialButton,
  },
  data: () => ({
    sendResultFailed: false,
    isSending: true,
  }),
  mounted: function() {
    this.sendResult()
  },
  methods: {
    sendResult() {
      // APIに結果を送信
      this.isSending = true

      const sortById = (a, b) => (a.id - b.id)

      let answers = this.$store.state.answer.sort(sortById).reduce( (result, current) => {
        result[`Q${current.id}`] = current.questions.reduce( (result, current) => {
          result[parseInt(current.id) - 1] = current.answer
          return result
        }, [] )
        return result
      }, {} )
      // console.log(answers)

      this.axios.post('/api/v1/test', answers).then(response => {
        console.log('post successful')
        console.log(response.data)
        if (response.data?.error) {
          this.sendResultFailed = true
        } else {
          this.$store.commit('saveResult', response.data)
          this.sendResultFailed = false
          this.$router.push('result')
        }
      }).catch(err => {
        console.log('post failed')
        console.log(err)
        this.sendResultFailed = true
      })

      this.isSending = false
    },
  },
}
</script>

<style scoped>
.el_container {
  padding: 0px 10% 0px 10%;
}
.ly_title {
  display: flex;
  position: relative;
  top: 48px;
  justify-content: space-between;
  font-size: 24px;
}
.el_title {
  position: relative;
  width: 117px;
  height: 53px;
  text-align: left;
  font-size: 36px;
  color: #6b6b6b;
}

.el_card_content {
  text-align: left;
  padding-top: 73px;
  padding-left: 63px;
  width: 602px;
  height: 152px;
  font-family: Noto Sans JP;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 35px;
}

.el_round_button {
  text-align: left;
  height: 60px;
  margin-top: 59px;
}
</style>
